import { Component, OnInit } from "@angular/core";
import { ChildEntityDisplayComponent } from "@app/view/shared/child-entity-display/child-entity-display.component";

@Component({
  selector: "app-child-entity-skill-rule-display",
  templateUrl: "./child-entity-skill-rule-display.component.html",
  styleUrls: ["./child-entity-skill-rule-display.component.css"]
})
export class ChildEntitySkillRuleDisplayComponent
  extends ChildEntityDisplayComponent
  implements OnInit
{
  ngOnInit() {
    console.log("child entity skill rule display");
    // super.ngOnInit();
    this._resource
      ?.getRelation(this._relation)
      .subscribe(
        (value) =>
          (this.displayValue = value[this._displayField] + " (REQUIRED)")
      );
  }
}
